module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/jszip/~/core-js/library/modules/_html.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_html.js
// module chunks = 3